import React from 'react';

import styles from './TaskHistoryDate.module.css';

type Props = {
  day: string;
  month: string;
};

export const TaskHistoryDate: React.FC<Props> = ({ day, month }) => {
  return (
    <>
      <div className={styles.month}>{month}</div>
      <div className={styles.day}>{day}</div>
    </>
  );
};
